<template>
    <div class="test-question-text-block" v-html="text"></div>
</template>

<script>
export default {
    name: "StatisticsQuestionTextBlock",
    props: {
        text: String,
    }
}
</script>

<style scoped lang="scss">
    @import 'resources/sass/variables';

    .test-question-text-block {
        font-size: 18px;
        background: #FAFAFA;
        border: 1px solid $tests-light-grey;
        border-radius: 6px;
        width: 100%;
        padding: 16px 8px 16px 16px;
    }
</style>